import { Component, ViewChild, TemplateRef, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SnotifyService } from 'ng-snotify';

import DayGridPlugin from '@fullcalendar/daygrid';
import TimeGridPlugin from '@fullcalendar/timegrid';
import InteractionPlugin from '@fullcalendar/interaction';
import ResourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { View } from '@fullcalendar/core/View';
import ListPlugin from '@fullcalendar/list';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { ExperienceScheduleService } from './experience-schedule.service';
import { EventInput } from '@fullcalendar/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Experience } from 'src/app/shared/models/experience.model';
import { ExperienceAggregator, DayStatus } from './helpers';


@Component({
  selector: 'app-experience-schedule',
  templateUrl: './experience-schedule.component.html',
  styleUrls: ['./experience-schedule.component.scss'],
})
export class ExperienceScheduleComponent implements OnInit, AfterViewInit {

  calendarEvents: EventInput = [];
  calendarPlugins = [
    DayGridPlugin,
    TimeGridPlugin,
    InteractionPlugin,
    // ResourceTimelinePlugin,
    ListPlugin
  ];

  get experienceId() {
    return this._experienceId;
  }
  set experienceId(id: number) {
    this._experienceId = id;
  }
  private _experienceId: number;


  experienceAggregator: ExperienceAggregator;

  experience: Experience;

  experiencesList: Experience[] = [];

  selectModel: any;

  modalProps = {
    ref: null as NgbModalRef,
    date: null as Date,
    events: [],
    status: 'BLOCKED' as DayStatus
  };

  @ViewChild('calendar', {static: true}) calendar: FullCalendarComponent;
  @ViewChild('modalTemplate', {static: true, read: TemplateRef}) modalTemplate: TemplateRef<any>;
  constructor(
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private experienceService: ExperienceScheduleService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      if (params.id) {
        this.experienceId = Number(params.id);
        if (this.experienceAggregator) {
          this.experienceAggregator.experiencesFilter.next(this.experienceId);
        }
        this.selectModel = this.experienceId;
      } else {
        this.experienceId = null;
        this.selectModel = 'all';
        if (this.experienceAggregator) {
          this.experienceAggregator.experiencesFilter.next(null);
        }
      }
    });
  }

  ngOnInit() {
    this.getAllExperiences();
  }

  ngAfterViewInit() {

  }

  refreshAggregatorExperiences() {
    this.experienceAggregator.collectEvents();
  }

  selectChange(newVal) {
    if (newVal === 'all') {
      this.router.navigate(['/experiences/schedule']);
    } else {
      this.router.navigate(['/experiences/schedule/' + newVal]);
    }
  }


  dateClickHandler(event: DateClickInterface) {
    this.modalProps.date = event.date;
    this.modalProps.events = this.experienceAggregator.getEventsAtDate(event.date);
    this.modalProps.status = this.experienceAggregator.checkDayStatus(event.date);
    this.showModal();
  }

  hideModal() {
    if (this.modalProps.ref) {
      this.modalProps.ref.dismiss();
    }
  }

  modalAction(event) {
    switch (event.action) {
      case 'block': {
        this.addBlockedDay(this.modalProps.date.toISOString());
        break;
      }
      case 'unblock': {
        this.unblockDay(this.modalProps.date.toISOString(), event.value);
        break;
      }
      case 'blockTime': {
        this.addBlockedDay(this.modalProps.date.toISOString(), event.value);
      }
    }
    this.hideModal();
  }

  private initAggregator(ids) {
    this.experienceAggregator = new ExperienceAggregator(ids, this.experienceService);
    this.experienceAggregator.events.subscribe(value => {
      this.calendarEvents = value;
    });

    if (this.experienceId) {
      this.experienceAggregator.experiencesFilter.next(this.experienceId);
    }
  }


  private unblockDay(day: string, extras?: any) {
    this.experienceAggregator.unblockDay(day, extras);
  }

  private addBlockedDay(day: string, extras?: any) {
    this.experienceAggregator.blockDay(day, extras);
  }

  private getAllExperiences() {
    this.experienceService.getAllExperiences().then(response => {
      this.experiencesList = response.data.experiences;
      this.initAggregator(
        this.experiencesList
      );
    }).catch(error => {
      this.notifier.error('Something went wrong, please try again later!');
    });
  }
  private showModal() {
    this.modalProps.ref = this.modalService.open(this.modalTemplate, {
      windowClass: 'animated fadeIn',
    });
  }
}

interface DateClickInterface {
  date: Date;
  dateStr: string;
  dayEl: Element;
  jsEvent: MouseEvent;
  view: View;
}
